<template>
  <div class="acts background-gradient" v-if="activitytypeList.length > 0">
    <div class="pageTop">{{ $t('Promotions') }}</div>
    
    <van-tabs v-model="actType" class="topsa" @click="activitylist" :swipe-threshold="1">
      <van-tab :title="$t('All Promotions')" :name="''"> </van-tab>
      <van-tab v-for="(item, index) in activitytypeList" :name="item.id" :title="getDynamicTabName(item.name)" :key="index"> </van-tab>
    </van-tabs>
    
    <div class="consg">
      <div v-if="activitylistList.length > 0" class="activity-list">
        <div
          class="lis"
          v-for="item in activitylistList"
          :key="item.id"
          role="button"
          tabindex="0"
          @click="$parent.goNav(`/activityInfo?id=${item.id}`)"
          @keyup.enter="$parent.goNav(`/activityInfo?id=${item.id}`)"
        >
          <div :class="['activity-wrapper', getActivityCardClass(item)]">
            <img :src="item.banner" alt="" class="activity-banner" aria-hidden="true" />
            <div class="activity-copy">
              <span class="activity-tag">{{ getActivityTypeName(item.type) }}</span>
              <h3>{{ getActivityTitle(item) }}</h3>
              <p>查看活动详情与参与规则</p>
              <span class="activity-link">查看详情 <b>›</b></span>
            </div>
          </div>
        </div>
      </div>
      <van-divider v-if="activitylistList.length > 0" dashed>{{ $t('END') }}</van-divider>
      <div v-else class="activity-empty">当前分类暂无活动</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'activity',
  data() {
    return {
      activitytypeList: [],
      actType: '',
      activitylistList: [],
    };
  },
  created() {
    let that = this;
    that.activitytype();
    that.activitylist();
  },
  methods: {
    getDynamicTabName(name) {
      const map = {
        '限时活动': 'Limited Time Offer',
        '新人福利': 'Newbie Benefits'
      };
      const key = map[name] || name;
      return this.$t(key);
    },
    getActivityTypeName(typeId) {
      const type = this.activitytypeList.find(item => String(item.id) === String(typeId));
      return type ? this.getDynamicTabName(type.name) : this.$t('Promotions');
    },
    getActivityTitle(item) {
      const title = String(item.title || '').trim();
      return title && !/^\d+$/.test(title) ? title : this.getActivityTypeName(item.type);
    },
    getActivityCardClass(item) {
      const typeName = this.getActivityTypeName(item.type);
      return typeName.indexOf('新人') !== -1 || typeName.indexOf('Newbie') !== -1
        ? 'activity-card--newcomer'
        : 'activity-card--limited';
    },
    
    activitytype() {
      let that = this;
      that.$apiFun.post('/api/activitytype', {}).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitytypeList = res.data;
        }
      });
    },
    activitylist() {
      let that = this;
      let info = that.actType == '' ? {} : { type: that.actType };
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitylist', info).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.activitylistList = res.data.data;
        }
        that.$parent.hideLoading();
      });
    },
    changActType(val) {
      let that = this;
      if (val == that.actType) {
        return;
      }
      that.actType = val;
      that.activitylist();
    },
  },
  mounted() {},
  updated() {},
  beforeDestroy() {},
};
</script>

<style lang="scss">
/* 全局暗黑背景 */
.acts.background-gradient {
  background:
    radial-gradient(circle at 85% 18%, rgba(209, 160, 62, 0.12), transparent 32%),
    linear-gradient(180deg, #17191d 0%, #08090b 58%, #050506 100%);
  min-height: 100vh;
  box-sizing: border-box;
  color: #e0e0e0;
}

.acts .pageTop {
  background: linear-gradient(105deg, #075bd4 0%, #4c20bd 100%);
  color: white;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 201;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.acts .topsa {
  position: fixed;
  top: 50px; /* 紧贴顶部标题栏下方 */
  left: 0;
  width: 100%;
  z-index: 200;
  background: rgba(14, 15, 18, 0.96);
  padding: 10px 12px 8px;
  box-sizing: border-box;
}

.acts .topsa .van-tabs__wrap {
  height: 42px;
}

.acts .topsa .van-tabs__nav {
  background: #202226;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 42px;
  padding: 4px;
  margin: 0;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 13px;
  box-sizing: border-box;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; 
  scrollbar-width: none;
}

.acts .topsa .van-tabs__nav::-webkit-scrollbar {
  display: none;
}

.acts .topsa .van-tab {
  flex: 1 0 104px !important;
  min-width: 104px;
  padding: 0 12px !important;
  height: 34px;
  line-height: 34px;
  background: transparent !important;
  color: #a8a9ad;
  border-radius: 9px;
  border: 0;
  margin-right: 4px;
  transition: all 0.3s ease;
  white-space: nowrap; 
}

.acts .topsa .van-tab--active {
  background: linear-gradient(135deg, #ffe49a, #d8a62e) !important;
  color: #4d3100 !important;
  font-weight: bold;
  box-shadow: 0 3px 12px rgba(216, 166, 46, 0.3);
}

.acts .topsa .van-tab__text {
  font-size: 14px;
}

.acts .topsa .van-tabs__line {
  display: none;
}

.acts .consg {
  padding: 112px 14px 90px;

  .van-divider {
    margin: 28px 0 0;
    color: #686a70;
    border-color: #303238;
    font-size: 12px;
    letter-spacing: 1px;
  }
  
  .lis {
    margin-bottom: 14px;
    background: #15171b;
    border-radius: 15px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.32);
    border: 1px solid rgba(255, 224, 145, 0.15);
    overflow: hidden;
    cursor: pointer;
    outline: none;

    &:active {
      transform: scale(0.99);
    }

    &:focus-visible {
      box-shadow: 0 0 0 2px #d8a62e, 0 8px 24px rgba(0, 0, 0, 0.32);
    }
    
    .activity-wrapper {
      position: relative;
      width: 100%;
      height: 138px;
      overflow: hidden;
      isolation: isolate;

      &::before {
        content: '';
        position: absolute;
        inset: 0;
        z-index: 1;
        background:
          linear-gradient(100deg, rgba(14, 17, 24, 0.99) 0%, rgba(17, 20, 27, 0.96) 52%, rgba(17, 20, 27, 0.48) 100%);
      }

      &::after {
        content: '';
        position: absolute;
        width: 120px;
        height: 120px;
        right: -28px;
        top: -42px;
        z-index: 1;
        border-radius: 50%;
        background: rgba(216, 166, 46, 0.2);
        filter: blur(2px);
      }

      &.activity-card--newcomer::after {
        background: rgba(40, 180, 119, 0.2);
      }
      
      .activity-banner {
        position: absolute;
        z-index: 0;
        top: 0;
        right: -18px;
        width: 76%;
        height: 100%;
        display: block;
        object-fit: cover;
        object-position: right center;
        opacity: 0.24;
        -webkit-mask-image: linear-gradient(to left, #000 35%, transparent 94%);
        mask-image: linear-gradient(to left, #000 35%, transparent 94%);
      }

      .activity-copy {
        position: absolute;
        inset: 0;
        z-index: 2;
        padding: 16px 18px;
        box-sizing: border-box;

        .activity-tag {
          display: inline-flex;
          align-items: center;
          height: 22px;
          padding: 0 10px;
          border: 1px solid rgba(255, 224, 145, 0.35);
          border-radius: 999px;
          color: #f5cf73;
          background: rgba(216, 166, 46, 0.1);
          font-size: 11px;
          font-weight: 600;
        }

        h3 {
          max-width: 72%;
          margin: 10px 0 4px;
          color: #f5f6f8;
          font-size: 18px;
          line-height: 1.25;
          font-weight: 700;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        p {
          margin: 0;
          color: #979ba5;
          font-size: 12px;
        }

        .activity-link {
          position: absolute;
          left: 18px;
          bottom: 14px;
          color: #e3bd61;
          font-size: 12px;

          b {
            margin-left: 3px;
            font-size: 16px;
          }
        }
      }
    }
  }

  .activity-card--newcomer .activity-copy .activity-tag {
    border-color: rgba(72, 210, 142, 0.38);
    color: #71dca8;
    background: rgba(40, 180, 119, 0.1);
  }

  .activity-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 260px;
    color: #777b84;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/activity.vue